export const catchyMapsBasemapRelease = "catchy-maps-v1-20260907T123608Z";
// The legacy same-origin proxy continues to serve this immutable release for
// already-loaded clients. New styles resolve this stable v1 TileJSON document,
// so compatible national bakes can change without a consumer code change.
export const catchyMapsTileJsonUrl =
  "https://sparkytype.syd1.cdn.digitaloceanspaces.com/basemap/new-zealand/catchy-maps-v1.json?v=catchy-maps-v1-20260909T014100Z";
export const catchyMapsConsumerPresentation =
  "catchy-web-20260909-profile-v2";

export const catchyMapsSourceKinds = Object.freeze({
  basemap: "tiles",
});

export const catchyMapsMaximumTileZoom = 14;
export const catchyMapsMaximumRequestZoom = 24;
